import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

// Contexts
import { ThemeProvider } from "./components/theme-provider";
import { AuthProvider } from "./contexts/AuthContext";

// Layouts
import AppLayout from "./components/layout/AppLayout";
import AuthLayout from "./components/layout/AuthLayout";

// Routes
import ProtectedRoute from "./components/routes/ProtectedRoute";
import PublicRoute from "./components/routes/PublicRoute";

// Forms
import LoginForm from "./components/forms/LoginForm";
import RegisterForm from "./components/forms/RegisterForm";

// Pages
import BillingCancelPage from "./components/pages/BillingCancelPage";
import BillingPage from "./components/pages/BillingPage";
import BillingSuccessPage from "./components/pages/BillingSuccessPage";
import Dashboard from "./components/pages/Dashboard";
import EmployeesPage from "./components/pages/EmployeesPage";
import NotFoundPage from "./components/pages/NotFoundPage";
import ProfilePage from "./components/pages/ProfilePage";
import SettingsPage from "./components/pages/SettingsPage";
import TagsPage from "./components/pages/TagsPage";
import VerificationFlow from "./components/pages/VerificationFlow";
import Widget from "./components/pages/Widget";

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="hrkyc-ui-theme">
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public routes */}
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <AuthLayout>
                      <LoginForm />
                    </AuthLayout>
                  </PublicRoute>
                }
              />
              <Route
                path="/signup"
                element={
                  <PublicRoute>
                    <AuthLayout>
                      <RegisterForm />
                    </AuthLayout>
                  </PublicRoute>
                }
              />

              {/* Protected routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Dashboard />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/widget"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Widget />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/employees"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <EmployeesPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <ProfilePage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/billing"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <BillingPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <SettingsPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tags"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <TagsPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />

              {/* Test route */}
              <Route path="/test" element={<div>Test Route Working!</div>} />

              {/* Billing routes (public) */}
              <Route path="/billing/success" element={<BillingSuccessPage />} />
              <Route path="/billing/cancel" element={<BillingCancelPage />} />

              {/* Verification flow (public but special) */}
              <Route path="/verify/:token" element={<VerificationFlow />} />
              <Route
                path="/verification/:token"
                element={<VerificationFlow />}
              />

              {/* 404 - Catch all unmatched routes */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Toaster />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
